// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  min-height: 100vh;
  background: var(--bg-primary);
}

/* Dark theme support for about page */
[data-theme="dark"] .about-page {
  background: var(--bg-primary);
}

.about-main {
  padding: 2rem 0;
}

.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.about-header {
  margin-bottom: 3rem;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.9);
  color: #495057;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0.8rem 1.5rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.back-btn:hover {
  background: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.about-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.about-emoji {
  font-size: 3rem;
  animation: wave 2s ease-in-out infinite;
}

@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(20deg); }
  75% { transform: rotate(-10deg); }
}

.about-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #8B4513, #D2B48C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.about-subtitle {
  font-size: 1.2rem;
  color: #495057;
  line-height: 1.6;
  max-width: 600px;
  margin: 0;
}

.about-content {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.1),
    0 1px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.about-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #8B4513, #D2B48C, #F5DEB3);
  border-radius: 20px 20px 0 0;
}

.content-section-header {
  margin-bottom: 2rem;
  text-align: center;
}

.content-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #8B4513, #D2B48C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.content-icon {
  font-size: 2rem;
  animation: wave 2s ease-in-out infinite;
}

.about-intro {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 2px solid #e9ecef;
}

.about-intro p {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #495057;
  margin: 0;
  text-align: justify;
  font-weight: 500;
}

.about-details {
  margin-bottom: 2rem;
}

.about-details p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #495057;
  margin-bottom: 1.5rem;
  text-align: justify;
}

.about-details p:last-of-type {
  margin-bottom: 0;
}

.about-cta {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 15px;
  padding: 2rem;
  margin-top: 2rem;
  border-left: 4px solid #8B4513;
  position: relative;
}

.about-cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(139, 69, 19, 0.05), rgba(210, 180, 140, 0.05));
  border-radius: 15px;
  pointer-events: none;
}

.about-cta p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #495057;
  margin: 0;
  position: relative;
  z-index: 1;
  font-weight: 500;
}

.cta-icon {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

/* Experience Section Styles */
.experience-section {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  padding: 3rem;
  margin-top: 2rem;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.1),
    0 1px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.experience-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3498db, #2980b9, #1abc9c);
  border-radius: 20px 20px 0 0;
}

.experience-header {
  margin-bottom: 3rem;
  text-align: center;
}

.experience-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 1rem 0;
  background: linear-gradient(135deg, #3498db, #2980b9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.experience-icon {
  font-size: 2.5rem;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.experience-subtitle {
  font-size: 1.1rem;
  color: #495057;
  margin: 0;
  font-weight: 500;
}

.experience-timeline {
  position: relative;
  padding-left: 2rem;
}

.experience-timeline::before {
  content: '';
  position: absolute;
  left: 1rem;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(180deg, #3498db, #2980b9, #1abc9c);
  border-radius: 1px;
}

.experience-item {
  position: relative;
  margin-bottom: 3rem;
  padding-left: 2rem;
}

.experience-item:last-child {
  margin-bottom: 0;
}

.experience-marker {
  position: absolute;
  left: -1.5rem;
  top: 0.5rem;
  width: 1rem;
  height: 1rem;
  background: white;
  border: 3px solid #3498db;
  border-radius: 50%;
  z-index: 2;
}

.marker-dot {
  width: 100%;
  height: 100%;
  background: #3498db;
  border-radius: 50%;
  transform: scale(0.6);
  transition: transform 0.3s ease;
}

.experience-item:hover .marker-dot {
  transform: scale(1);
}

.experience-content {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  padding: 2rem;
  border: 1px solid rgba(52, 152, 219, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.experience-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.05), rgba(26, 188, 156, 0.05));
  border-radius: 15px;
  pointer-events: none;
}

.experience-content:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(52, 152, 219, 0.2);
  border-color: #3498db;
}

.experience-header-item {
  margin-bottom: 1.5rem;
}

.experience-company {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 0.8rem 0;
  position: relative;
  z-index: 1;
}

.experience-role,
.experience-period {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: #495057;
  position: relative;
  z-index: 1;
}

.role-icon,
.period-icon {
  font-size: 1.1rem;
}

.experience-description {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 1;
}

.experience-description li {
  position: relative;
  padding-left: 1.5rem;
  margin-bottom: 0.8rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #495057;
}

.experience-description li::before {
  content: '▸';
  position: absolute;
  left: 0;
  color: #3498db;
  font-weight: bold;
  font-size: 1.2rem;
}

.experience-description li:last-child {
  margin-bottom: 0;
}

/* Dark theme support - removed duplicate background */

[data-theme="dark"] .back-btn {
  background: rgba(52, 73, 94, 0.9);
  color: #ecf0f1;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .back-btn:hover {
  background: #34495e;
}

[data-theme="dark"] .about-title {
  background: linear-gradient(135deg, #D2B48C, #F5DEB3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="dark"] .about-content {
  background: rgba(44, 62, 80, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .about-intro p,
[data-theme="dark"] .about-details p {
  color: #ecf0f1;
}

[data-theme="dark"] .about-cta {
  background: linear-gradient(135deg, #34495e, #2c3e50);
  border-left-color: #D2B48C;
}

[data-theme="dark"] .about-cta p {
  color: #ecf0f1;
}

[data-theme="dark"] .about-subtitle {
  color: #ecf0f1;
}

[data-theme="dark"] .content-title {
  background: linear-gradient(135deg, #D2B48C, #F5DEB3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="dark"] .experience-section {
  background: rgba(44, 62, 80, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .experience-title {
  background: linear-gradient(135deg, #3498db, #1abc9c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="dark"] .experience-subtitle {
  color: #ecf0f1;
}

[data-theme="dark"] .experience-content {
  background: rgba(44, 62, 80, 0.8);
  border: 1px solid rgba(52, 152, 219, 0.3);
}

[data-theme="dark"] .experience-content::before {
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.1), rgba(26, 188, 156, 0.1));
}

[data-theme="dark"] .experience-company {
  color: #ecf0f1;
}

[data-theme="dark"] .experience-role,
[data-theme="dark"] .experience-period {
  color: #bdc3c7;
}

[data-theme="dark"] .experience-description li {
  color: #bdc3c7;
}

/* Responsive design */
@media (max-width: 768px) {
  .about-main {
    padding: 1rem 0;
  }
  
  .about-container {
    padding: 0 0.5rem;
  }
  
  .about-content {
    padding: 1.5rem;
  }
  
  .about-title {
    font-size: 2rem;
  }
  
  .about-emoji {
    font-size: 2rem;
  }
  
  .about-intro p {
    font-size: 1.1rem;
  }
  
  .about-details p {
    font-size: 1rem;
  }
  
  .about-cta {
    padding: 1.5rem;
  }
  
  .about-cta p {
    font-size: 1rem;
  }

  .about-subtitle {
    font-size: 1.1rem;
  }

  .content-title {
    font-size: 1.5rem;
  }

  .content-icon {
    font-size: 1.5rem;
  }

  .experience-section {
    padding: 1.5rem;
    margin-top: 1.5rem;
  }

  .experience-title {
    font-size: 2rem;
  }

  .experience-icon {
    font-size: 2rem;
  }

  .experience-timeline {
    padding-left: 1.5rem;
  }

  .experience-timeline::before {
    left: 0.75rem;
  }

  .experience-item {
    padding-left: 1.5rem;
    margin-bottom: 2rem;
  }

  .experience-marker {
    left: -1.25rem;
  }

  .experience-content {
    padding: 1.5rem;
  }

  .experience-company {
    font-size: 1.2rem;
  }

  .experience-role,
  .experience-period {
    font-size: 0.9rem;
  }

  .experience-description li {
    font-size: 0.9rem;
  }

  /* Hide "deneyimlerim" text in mobile view */
  .about-subtitle {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AboutPage/AboutPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd,oCAAoC;EACpC,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,wBAAwB,EAAE;EAChC,MAAM,yBAAyB,EAAE;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb;;iCAE+B;EAC/B,0CAA0C;EAC1C,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uFAAuF;EACvF,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB;;iCAE+B;EAC/B,0CAA0C;EAC1C,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uFAAuF;EACvF,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sDAAsD;;AAEtD;EACE,iCAAiC;EACjC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,4CAA4C;EAC5C;IACE,aAAa;EACf;AACF","sourcesContent":[".about-page {\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n\n/* Dark theme support for about page */\n[data-theme=\"dark\"] .about-page {\n  background: var(--bg-primary);\n}\n\n.about-main {\n  padding: 2rem 0;\n}\n\n.about-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.about-header {\n  margin-bottom: 3rem;\n}\n\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.9);\n  color: #495057;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 0.8rem 1.5rem;\n  border-radius: 50px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.back-btn:hover {\n  background: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n}\n\n.about-title-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.about-emoji {\n  font-size: 3rem;\n  animation: wave 2s ease-in-out infinite;\n}\n\n@keyframes wave {\n  0%, 100% { transform: rotate(0deg); }\n  25% { transform: rotate(20deg); }\n  75% { transform: rotate(-10deg); }\n}\n\n.about-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n  background: linear-gradient(135deg, #8B4513, #D2B48C);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.about-subtitle {\n  font-size: 1.2rem;\n  color: #495057;\n  line-height: 1.6;\n  max-width: 600px;\n  margin: 0;\n}\n\n.about-content {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 20px;\n  padding: 3rem;\n  box-shadow: \n    0 10px 30px rgba(0, 0, 0, 0.1),\n    0 1px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  position: relative;\n  overflow: hidden;\n}\n\n.about-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #8B4513, #D2B48C, #F5DEB3);\n  border-radius: 20px 20px 0 0;\n}\n\n.content-section-header {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.content-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n  background: linear-gradient(135deg, #8B4513, #D2B48C);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.content-icon {\n  font-size: 2rem;\n  animation: wave 2s ease-in-out infinite;\n}\n\n.about-intro {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.about-intro p {\n  font-size: 1.2rem;\n  line-height: 1.8;\n  color: #495057;\n  margin: 0;\n  text-align: justify;\n  font-weight: 500;\n}\n\n.about-details {\n  margin-bottom: 2rem;\n}\n\n.about-details p {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #495057;\n  margin-bottom: 1.5rem;\n  text-align: justify;\n}\n\n.about-details p:last-of-type {\n  margin-bottom: 0;\n}\n\n.about-cta {\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n  border-radius: 15px;\n  padding: 2rem;\n  margin-top: 2rem;\n  border-left: 4px solid #8B4513;\n  position: relative;\n}\n\n.about-cta::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(139, 69, 19, 0.05), rgba(210, 180, 140, 0.05));\n  border-radius: 15px;\n  pointer-events: none;\n}\n\n.about-cta p {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #495057;\n  margin: 0;\n  position: relative;\n  z-index: 1;\n  font-weight: 500;\n}\n\n.cta-icon {\n  font-size: 1.2rem;\n  margin-right: 0.5rem;\n}\n\n/* Experience Section Styles */\n.experience-section {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 20px;\n  padding: 3rem;\n  margin-top: 2rem;\n  box-shadow: \n    0 10px 30px rgba(0, 0, 0, 0.1),\n    0 1px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  position: relative;\n  overflow: hidden;\n}\n\n.experience-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3498db, #2980b9, #1abc9c);\n  border-radius: 20px 20px 0 0;\n}\n\n.experience-header {\n  margin-bottom: 3rem;\n  text-align: center;\n}\n\n.experience-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0 0 1rem 0;\n  background: linear-gradient(135deg, #3498db, #2980b9);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.experience-icon {\n  font-size: 2.5rem;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n.experience-subtitle {\n  font-size: 1.1rem;\n  color: #495057;\n  margin: 0;\n  font-weight: 500;\n}\n\n.experience-timeline {\n  position: relative;\n  padding-left: 2rem;\n}\n\n.experience-timeline::before {\n  content: '';\n  position: absolute;\n  left: 1rem;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: linear-gradient(180deg, #3498db, #2980b9, #1abc9c);\n  border-radius: 1px;\n}\n\n.experience-item {\n  position: relative;\n  margin-bottom: 3rem;\n  padding-left: 2rem;\n}\n\n.experience-item:last-child {\n  margin-bottom: 0;\n}\n\n.experience-marker {\n  position: absolute;\n  left: -1.5rem;\n  top: 0.5rem;\n  width: 1rem;\n  height: 1rem;\n  background: white;\n  border: 3px solid #3498db;\n  border-radius: 50%;\n  z-index: 2;\n}\n\n.marker-dot {\n  width: 100%;\n  height: 100%;\n  background: #3498db;\n  border-radius: 50%;\n  transform: scale(0.6);\n  transition: transform 0.3s ease;\n}\n\n.experience-item:hover .marker-dot {\n  transform: scale(1);\n}\n\n.experience-content {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 15px;\n  padding: 2rem;\n  border: 1px solid rgba(52, 152, 219, 0.2);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.experience-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(52, 152, 219, 0.05), rgba(26, 188, 156, 0.05));\n  border-radius: 15px;\n  pointer-events: none;\n}\n\n.experience-content:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 35px rgba(52, 152, 219, 0.2);\n  border-color: #3498db;\n}\n\n.experience-header-item {\n  margin-bottom: 1.5rem;\n}\n\n.experience-company {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0 0 0.8rem 0;\n  position: relative;\n  z-index: 1;\n}\n\n.experience-role,\n.experience-period {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n  color: #495057;\n  position: relative;\n  z-index: 1;\n}\n\n.role-icon,\n.period-icon {\n  font-size: 1.1rem;\n}\n\n.experience-description {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.experience-description li {\n  position: relative;\n  padding-left: 1.5rem;\n  margin-bottom: 0.8rem;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #495057;\n}\n\n.experience-description li::before {\n  content: '▸';\n  position: absolute;\n  left: 0;\n  color: #3498db;\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n\n.experience-description li:last-child {\n  margin-bottom: 0;\n}\n\n/* Dark theme support - removed duplicate background */\n\n[data-theme=\"dark\"] .back-btn {\n  background: rgba(52, 73, 94, 0.9);\n  color: #ecf0f1;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .back-btn:hover {\n  background: #34495e;\n}\n\n[data-theme=\"dark\"] .about-title {\n  background: linear-gradient(135deg, #D2B48C, #F5DEB3);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"dark\"] .about-content {\n  background: rgba(44, 62, 80, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .about-intro p,\n[data-theme=\"dark\"] .about-details p {\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .about-cta {\n  background: linear-gradient(135deg, #34495e, #2c3e50);\n  border-left-color: #D2B48C;\n}\n\n[data-theme=\"dark\"] .about-cta p {\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .about-subtitle {\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .content-title {\n  background: linear-gradient(135deg, #D2B48C, #F5DEB3);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"dark\"] .experience-section {\n  background: rgba(44, 62, 80, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .experience-title {\n  background: linear-gradient(135deg, #3498db, #1abc9c);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"dark\"] .experience-subtitle {\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .experience-content {\n  background: rgba(44, 62, 80, 0.8);\n  border: 1px solid rgba(52, 152, 219, 0.3);\n}\n\n[data-theme=\"dark\"] .experience-content::before {\n  background: linear-gradient(135deg, rgba(52, 152, 219, 0.1), rgba(26, 188, 156, 0.1));\n}\n\n[data-theme=\"dark\"] .experience-company {\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .experience-role,\n[data-theme=\"dark\"] .experience-period {\n  color: #bdc3c7;\n}\n\n[data-theme=\"dark\"] .experience-description li {\n  color: #bdc3c7;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .about-main {\n    padding: 1rem 0;\n  }\n  \n  .about-container {\n    padding: 0 0.5rem;\n  }\n  \n  .about-content {\n    padding: 1.5rem;\n  }\n  \n  .about-title {\n    font-size: 2rem;\n  }\n  \n  .about-emoji {\n    font-size: 2rem;\n  }\n  \n  .about-intro p {\n    font-size: 1.1rem;\n  }\n  \n  .about-details p {\n    font-size: 1rem;\n  }\n  \n  .about-cta {\n    padding: 1.5rem;\n  }\n  \n  .about-cta p {\n    font-size: 1rem;\n  }\n\n  .about-subtitle {\n    font-size: 1.1rem;\n  }\n\n  .content-title {\n    font-size: 1.5rem;\n  }\n\n  .content-icon {\n    font-size: 1.5rem;\n  }\n\n  .experience-section {\n    padding: 1.5rem;\n    margin-top: 1.5rem;\n  }\n\n  .experience-title {\n    font-size: 2rem;\n  }\n\n  .experience-icon {\n    font-size: 2rem;\n  }\n\n  .experience-timeline {\n    padding-left: 1.5rem;\n  }\n\n  .experience-timeline::before {\n    left: 0.75rem;\n  }\n\n  .experience-item {\n    padding-left: 1.5rem;\n    margin-bottom: 2rem;\n  }\n\n  .experience-marker {\n    left: -1.25rem;\n  }\n\n  .experience-content {\n    padding: 1.5rem;\n  }\n\n  .experience-company {\n    font-size: 1.2rem;\n  }\n\n  .experience-role,\n  .experience-period {\n    font-size: 0.9rem;\n  }\n\n  .experience-description li {\n    font-size: 0.9rem;\n  }\n\n  /* Hide \"deneyimlerim\" text in mobile view */\n  .about-subtitle {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
